import {
  ChartColumnDecreasingIcon,
  ChartScatterIcon,
  FilePenLineIcon,
} from 'lucide-animated';
import {
  useEffect,
  useRef,
  type ComponentType,
  type RefAttributes,
} from 'react';

import { useCycledIndex } from './useCycledIndex';

interface AnimatedIconHandle {
  startAnimation: () => void;
  stopAnimation: () => void;
}

type AnimatedIcon = ComponentType<
  { size?: number; className?: string } & RefAttributes<AnimatedIconHandle>
>;

const ARTIFACT_ICONS: AnimatedIcon[] = [
  ChartColumnDecreasingIcon,
  ChartScatterIcon,
  FilePenLineIcon,
];
const ICON_DWELL_MS = 3_000;

export function ArtifactIconCycle({ size }: { size: number }) {
  const iconIndex = useCycledIndex(ARTIFACT_ICONS.length, ICON_DWELL_MS);
  const iconRef = useRef<AnimatedIconHandle>(null);

  useEffect(() => {
    const frame = requestAnimationFrame(() =>
      iconRef.current?.startAnimation()
    );
    return () => cancelAnimationFrame(frame);
  }, [iconIndex]);

  const Icon = ARTIFACT_ICONS[iconIndex];
  return <Icon key={iconIndex} ref={iconRef} size={size} />;
}
